import { Stack, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Icon from 'components/Icon'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'
import { OBSERVABILITY_TOOL_DISPLAY_NAME } from 'utils/status-checks/status-checks-utils'

import type { TeamExternalIntegration } from 'types/api/status-checks/status-check'

export const ObservabilityToolEditor: React.FC<{
  integration: TeamExternalIntegration
}> = ({ integration }) => {
  const statusCheckUrls = getStatusChecksUrls()

  return (
    <Stack alignItems="baseline" direction="row" spacing={1}>
      <Typography data-test-edit-status-check-title mr={1}>
        Observability Tool:
      </Typography>
      <Typography>
        {integration.observabilityToolType === ObservabilityToolType.GRAFANA
          ? OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.GRAFANA]
          : integration.name}
      </Typography>
      <Typography
        component={RouterLink}
        to={statusCheckUrls.editAuthenticationFromTeamExternalIntegration(
          integration
        )}
      >
        <Icon icon="edit" />
      </Typography>
    </Stack>
  )
}
